import React, { createContext, useState, useEffect } from 'react';
import styled,{keyframes} from 'styled-components'
import { Loader } from 'semantic-ui-react';



const Suggestions = ({data,selectFollowUp}) =>{

    if(data.data.length === 0){
        return ""
    }

    // Filter out suggestions for areas with no feedback
    const suggestionsWithFeedback = data.data.filter(d => {
        // Add your specific condition here - this assumes feedback exists if there's meaningful data
        // You may need to adjust this condition based on your data structure
        return d.groupValue && d.categoryColumn && d.feedback && d.feedback.length > 0;
    });

    // If no suggestions have feedback, don't display anything
    if(suggestionsWithFeedback.length === 0){
        return ""
    }

    return (
        <Container>
            <Title>
                Suggested Next Steps
            </Title>
            <SuggestionArea>
                <ul>
                    {suggestionsWithFeedback.slice(0,3).map((d,i)=>{

                        return (
                            <Bubble key={i} onClick={()=>selectFollowUp(i)}>{`Explore themes for ${d.groupValue} ${d.categoryColumn}`}</Bubble>
                        )   
                    })
                    }
                </ul>

            </SuggestionArea>
        </Container>
    )
}

export default Suggestions;


const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const Container = styled.div`
    display:flex;
    flex-direction: column;
    width:100%;
    font-family: 'Raleway', sans-serif;
    opacity: 0;
  animation: ${fadeIn} 0.5s forwards;
`

const Title = styled.div`
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 5px;
    margin-top:20px;

`
const SuggestionArea = styled.div`
    display:flex;
    width:100%;
    flex-direction: column;
`

const Bubble = styled.li`
    margin-right: 10px;
    cursor: pointer;
    font-size: 12px;
    color:#2D70E2;
    font-weight: 600;
    margin-bottom:5px;
`